<template>
	<footer>
		<app-container class="text-xs-center">
			<v-layout wrap>
				<v-flex xs12 md6>
					<v-card dark class="equalize">
						<v-card-text>
							<h2 id="contact">Contact Us</h2>

							<v-divider class="w-50 mt-2 mb-4 mx-auto" />

							<span
								v-for="info in addressInfo"
								:key="info"
								class="d-block my-1"
							>{{ info }}</span>

							<v-divider class="w-50 mb-2 mt-4 mx-auto" />

							<app-contact-btns />
						</v-card-text>
					</v-card>
				</v-flex>

				<v-flex xs12 md6>
					<v-card dark class="equalize">
						<v-card-text>
							<h2>Ratings and Reviews</h2>

							<v-divider class="w-50 my-2 mx-auto" />

							<v-rating :value="5" color="amber" />

							<v-layout justify-center>
								<v-flex xs10 sm8 lg7>
									<v-btn
										v-for="(item) in ratingsReviews"
										:key="item.href"
										v-external
										block
										:href="item.href"
										class="pa-4"
									>
										<app-img v-wh="32" :data-src="'/img/' + item.img" class="d-block mr-3" />
										{{ item.name }}
										<v-spacer />
									</v-btn>
								</v-flex>
							</v-layout>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>

			<v-layout>
				<v-flex>
					<p>© 2019 All Star Kids Academy</p>
				</v-flex>
			</v-layout>
		</app-container>
	</footer>
</template>

<script>
export default {
	data: () => ({
		addressInfo: [
			'21 Greenwood Lake Turnpike',
			'Ringwood, NJ 07456',
			'(973) 839 - 0737',
			'allstarkidsnj@gmail.com',
		],
		ratingsReviews: [
			{
				name: 'Facebook',
				img: 'logo-facebook.png',
				href: 'https://www.facebook.com/pg/allstarkidsacademy/reviews/',
			},
			{
				name: 'Google',
				img: 'logo-google-small.png',
				href: 'https://www.google.com/search?source=hp&ei=4OrZW9T4O9C-ggeFhZ6AAQ&q=all+star+kids+academy&btnK=Google+Search&oq=a&gs_l=psy-ab.3.0.35i39l2j0i131l4j0l2j0i131j0.1151.1759..3248...1.0..0.271.446.2j0j1......0....1..gws-wiz.....6.RtWsUqPJnIk#btnK=Google%20Search&lrd=0x89c31c275bd7f1b7:0xd700726ede68bcf7,1,,,',
			},
			{
				name: 'GreatSchools.org',
				img: 'logo-greatschools-small.png',
				href: 'https://www.greatschools.org/new-jersey/ringwood/6362-All-Star-Kids-Academy/',
			},
		],
	}),
}
</script>

<style>
footer {
	background: #333;
}
</style>
